export const environment = {
  production: false,
  apiUrl: '/api',
  googleMapsApiKey: 'AIzaSyCuvE2xyxE5jSTrOmUIcPiJ70bsoW1oPZs',
  appUrl: '',
  // URL of the public marketing app — used on login page logo to redirect back
  publicUrl: 'https://stage-site.pharmigo.co',
};
